import React from 'react';
import { Feature, PhotoItemValue, VideoItemValue } from '@fulcrumapp/fulcrum-core';
import PlayArrowTwoToneIcon from '@mui/icons-material/PlayArrowTwoTone';
import ModalMediaViewer from './modal-media-viewer';
import { AppContext } from '../../hooks/use-app';
import { cssInJS } from '../../utils/styles';
import displayableItemForItem from './display/displayable-item-for-item';

type Props = {
  item: PhotoItemValue | VideoItemValue;
  mediaValueItems: Array<PhotoItemValue | VideoItemValue>;
  feature: Feature;
}

type State = {
  viewing: boolean;
}

export default class PhotoGalleryItem extends React.Component<Props, State> {
  static contextType = AppContext;

  constructor(props, context) {
    super(props, context);

    this.state = {
      viewing: false,
    };
  }

  render() {
    // @ts-ignore
    const { styles } = PhotoGalleryItem;

    return (
      <div className={styles.itemContainer}>
        {this.renderContent()}
        {this.renderViewer()}
      </div>
    );
  }

  renderContent = () => {
    // @ts-ignore
    const { styles } = PhotoGalleryItem;

    if (this.props.item instanceof PhotoItemValue) {
      const photoURL = this.context.dataSource.source.getPhotoThumbnailURL(this.props.item.mediaID);
      return (
        <img
          className={css(styles.thumbnail)}
          src={photoURL}
          onClick={this.handleOpenViewer}
          title={this.props.item.mediaValue.element.label}
        />
      );
    } if (this.props.item instanceof VideoItemValue) {
      const videoURL = this.context.dataSource.source.getVideoThumbnailURL(this.props.item.mediaID);
      return (
        <>
          <div className={styles.overlay} onClick={this.handleOpenViewer}>
            <PlayArrowTwoToneIcon className={styles.playIcon} />
          </div>
          <img
            className={css(styles.thumbnail)}
            src={videoURL}
            title={this.props.item.mediaValue.element.label}
          />
        </>
      );
    }
    return <></>;
  };

  renderViewer = () => {
    const displayableItems = this.props.mediaValueItems
      .map(mediaItem => displayableItemForItem(mediaItem, this.context.dataSource));
    const initialDisplayableItem = displayableItemForItem(this.props.item, this.context.dataSource);
    return (
      <ModalMediaViewer
        feature={this.props.feature}
        mapVisible
        mediaValueItems={displayableItems}
        initialItem={initialDisplayableItem}
        visible={this.state.viewing}
        onClose={this.handleCloseViewer}
      />
    );
  };

  handleOpenViewer = () => this.setState({ viewing: true });

  handleCloseViewer = () => this.setState({ viewing: false });
}

const styles = cssInJS({
  thumbnail: {
    maxWidth: 150,
    marginRight: 10,
    cursor: 'pointer',
    marginBottom: 10,
    borderRadius: 3,
  },

  overlay: {
    cursor: 'pointer',
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },

  playIcon: {
    position: 'absolute',
    opacity: 0.75,
    backgroundColor: '#fff',
    width: 75,
    height: 75,
    left: '40%',
    bottom: '50%',
  },

  itemContainer: {
    position: 'relative',
    display: 'inline-block',
  },
}) as any;

// @ts-ignore
PhotoGalleryItem.styles = styles;
